import ChatBoxV2, {
  IPropsType as IChatboxV2PropsType,
} from '../../Routes/renderer/chatBoxV2'

const SousChefChatBox = ({
  agentCode,
  sendStoreId,
  width,
  height,
  hideFromNonExpoUsers,
}: Omit<IChatboxV2PropsType, 'type'>) => {
  return (
    <ChatBoxV2
      type="chatbox-v2"
      agentCode={agentCode}
      sendStoreId={sendStoreId}
      width={width}
      height={height}
      hideFromNonExpoUsers={hideFromNonExpoUsers}
    ></ChatBoxV2>
  )
}

export default SousChefChatBox
